interface IGetNormalizedValue {
  value?: string
  decimalSign: string
}

export const getNormalizedValue = ({ value, decimalSign }: IGetNormalizedValue) => {
  if (value) {
    return value.replace(new RegExp(`[^${decimalSign}\\d-]`, 'gm'), '').replace(decimalSign, '.')
  }

  return ''
}
